var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{class:[
      {
        cursorNotAllowed: _vm.cursorNotAllowed(),
        opacity: _vm.newOpacity(),
        icon: true,
        iconSelected: _vm.value
      },
      _vm.iconToShow
    ],attrs:{"title":_vm.title},on:{"click":function($event){return _vm.updateValue($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }